// src/pages/EntrepreneurshipEducationContent/GroupsContentPage.js
import React, { useState, useEffect } from 'react';
// Import your custom CSS file. Adjust path if necessary.
// e.g., if this file is in src/pages/EEC/ and GroupsContent.css is in src/styles/
// import '../../../styles/GroupsContent.css'; 
import '../../styles/GroupsContentPage.css'; // Assuming CSS is in src/styles/

// Assuming these are your actual components, correctly imported
import GroupsListPage from './GroupsListPage';
import MemberTransferContent from './MemberTransferContent';
import GroupScoreContent from './GroupScoreContent';
import GroupProjectsContent from './GroupProjectsContent';

const groupSections = ['Groups List', 'Member Transfer', 'Group Score', 'Group Projects'];

function GroupsContentPage({ currentScope, navigateToDashboardView }) {
  const [activeSection, setActiveSection] = useState(groupSections[0]);

  // Effect to reset activeSection to 'Groups List' when the currentScope changes
  // This ensures that when the user switches, e.g., from "Local Groups" to "National Groups",
  // they land on the "Groups List" for the new scope by default.
  useEffect(() => {
    setActiveSection(groupSections[0]); 
  }, [currentScope]);

  const handleSectionClick = (section) => {
    setActiveSection(section);
    console.log(`Navigating to: ${section} in scope: ${currentScope}`);
  };

  const renderContent = () => {
    // Pass currentScope to sub-components so they have context if needed
    switch (activeSection) {
      case 'Groups List':
        return <GroupsListPage currentScope={currentScope} />;
      case 'Member Transfer':
        return <MemberTransferContent currentScope={currentScope} />;
      case 'Group Score':
        return <GroupScoreContent currentScope={currentScope} />;
      case 'Group Projects':
        return <GroupProjectsContent currentScope={currentScope} />;
      default:
        return <GroupsListPage currentScope={currentScope} />;
    }
  };

  return (
    // Root element uses class from GroupsContent.css
    <div className="groups-content-page">
      {/* Breadcrumb: Wrapper uses Tailwind for general box styling, links use custom CSS */}
      <div className="breadcrumb bg-white p-3 rounded-lg shadow-sm border border-gray-200"> {/* Tailwind for wrapper */}
        <button 
            className="breadcrumb-link" // Styled by GroupsContent.css
            // Navigate back to the functional card overview for the current scope
            onClick={() => navigateToDashboardView('functionalCardOverview', currentScope)}
        >
          {currentScope} Menu 
        </button>
        <span>&gt;</span> {/* Styled by GroupsContent.css */}
        <span className="active-breadcrumb"> {/* Styled by GroupsContent.css */}
          Groups ({activeSection}) {/* Shows current scope and active group section */}
        </span>
      </div>

      {/* Content area uses class from GroupsContent.css */}
      <div className="content-area">
        {/* Sidebar uses class from GroupsContent.css */}
        <div className="groups-sidebar">
          <h3 className="sidebar-title">GROUPS</h3> {/* Styled by GroupsContent.css */}
          {groupSections.map(section => (
            <button
              key={section}
              // Uses group-button and active classes from GroupsContent.css
              className={`group-button ${activeSection === section ? 'active' : ''}`}
              onClick={() => handleSectionClick(section)}
            >
              {section}
            </button>
          ))}
        </div>

        {/* Content pane uses class from GroupsContent.css */}
        <div className="content-pane">
          {renderContent()}
        </div>
      </div>
    </div>
  );
}

export default GroupsContentPage;
